var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 30,
    viewBox: "0 0 150 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13C0.89543 13 0 13.8954 0 15C0 16.1046 0.89543 17 2 17V13ZM149.414 16.4142C150.195 15.6332 150.195 14.3668 149.414 13.5858L136.686 0.857864C135.905 0.0768156 134.639 0.0768156 133.858 0.857864C133.077 1.63891 133.077 2.90524 133.858 3.68629L145.172 15L133.858 26.3137C133.077 27.0948 133.077 28.3611 133.858 29.1421C134.639 29.9232 135.905 29.9232 136.686 29.1421L149.414 16.4142ZM2 17H148V13H2V17Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.40d0329639b13ca880d87566a7692136.svg";
export { ForwardRef as ReactComponent };